import { useRef, useState } from 'react'
import Image from 'next/image'

export default function OptimizedImage(props) {
  const {
    src = '',
    alt = 'Optimized image',
    height,
    width,
    placeholderBlur,
    priority = false,
    loading = 'lazy',
    style,
  } = props
  const isPercentage = (val) => typeof val === 'string' && val.includes('%')
  const useFill = isPercentage(width) || isPercentage(height)
  const containerRef = useRef(null)
  const [aspectRatio, setAspectRatio] = useState(null)
  const PLACEHOLDER_BLUR =
    placeholderBlur ||
    'data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPScxMCcgaGVpZ2h0PScxMCc+PHJlY3Qgd2lkdGg9JzEwMCUnIGhlaWdodD0nMTAwJScgZmlsbD0nI2NjYyc+PC9yZWN0Pjwvc3ZnPg=='

  const handleImageLoad = (e) => {
    const { naturalWidth, naturalHeight } = e.target
    const ratio = naturalWidth / naturalHeight
    setAspectRatio(ratio)
  }
  return useFill ? (
    <div
      ref={containerRef}
      style={{
        position: 'relative',
        width: '100%',
        ...(aspectRatio ? { aspectRatio } : { minHeight: 'auto' }),
      }}
    >
      <Image
        src={src}
        alt={alt}
        fill
        placeholder="blur"
        blurDataURL={PLACEHOLDER_BLUR}
        style={{ objectFit: 'cover', ...style }}
        priority={priority}
        onLoad={handleImageLoad}
        loading={priority ? 'eager' : 'lazy'}
      />
    </div>
  ) : (
    <Image
      src={src}
      alt={alt}
      width={Number(width)}
      height={Number(height)}
      placeholder="blur"
      blurDataURL={PLACEHOLDER_BLUR}
      priority={priority}
      onLoad={handleImageLoad}
      loading={priority ? 'eager' : 'lazy'}
      {...props}
    />
  )
}
